import { Point } from '../Types';

export function squarePoints(w: number, h: number, pins: number): Point[] {
  const result: Point[] = [];
  const step = (w + h) * 2 / pins;
  for (let x = 0; x < w; x += step) {
    result.push([x, 0]);
    result.push([x, h]);
  }
  for (let y = 0; y < h; y += step) {
    result.push([0, y]);
    result.push([w, y]);
  }
  return result;
}

export function ellipsoidPoints(center: Point, r1: number, r2: number, pins: number): Point[] {
  const result: Point[] = [];
  for (let i = 0; i < pins; i++) {
    const theta = 2 * Math.PI * i / pins;
    const x = Math.cos(theta) * r1 + center[0];
    const y = Math.sin(theta) * r2 + center[1];
    result.push([x, y]);
  }
  return result;
}

export function calculateResizedDimensions(originalWidth: number, originalHeight: number, maxDimension: number): { width: number, height: number } {
  const aspectRatio = originalHeight / originalWidth;
  
  if (originalWidth >= originalHeight) {
    return {
      width: maxDimension,
      height: Math.round(maxDimension * aspectRatio)
    };
  } else {
    return {
      width: Math.round(maxDimension / aspectRatio),
      height: maxDimension
    };
  }
}